import React from "react";

const Footer = () => {
  return (
    <footer className="d-flex justify-content-center bg_primary py-4 h-69">
      <small className="text-center text-white my-1">
        &copy; {new Date().getFullYear()} POMMe-Health
      </small>
    </footer>
  );
};

export default Footer;
